import { render, staticRenderFns } from "./workGoals.vue?vue&type=template&id=71b49c3f&scoped=true&"
import script from "./workGoals.vue?vue&type=script&lang=js&"
export * from "./workGoals.vue?vue&type=script&lang=js&"
import style0 from "./workGoals.vue?vue&type=style&index=0&id=71b49c3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b49c3f",
  null
  
)

export default component.exports